import { EventHandlers } from '@jbhi-fi/components/src/context/Events';
import { addInsight, postAlgoliaProductClick, postAlgoliaProductView } from '../../utils/algolia/search-insights';

export const algoliaEventHandlers: EventHandlers = {
  'component.carousel.view': data => postAlgoliaProductView(data),
  'component.productcard.click': ({ sku, queryId, position }) => {
    addInsight(sku, queryId);
    postAlgoliaProductClick(sku, position);
  },
};
